<div #scrollable class="scrollable">
  <div class='scroll__customized'>
    <ng-content></ng-content>
  </div>
</div>